import type { JSX } from 'react';

const REGISTRAR_EMAIL = 'registrar@confessinganglicans.nz';

/**
 * "Having any problems? Email registrar@…" — UX-6's escape hatch, word for
 * word, as the route that goes with every sentence telling someone to ask or
 * contact the Registrar, so the instruction never stands without a way to act
 * on it (cca-0x72d).
 *
 * `className` sets the line's size, colour and spacing. The default is the
 * quiet footnote of a white panel. Inside a tinted box, pass the box's own
 * text colour (or none, to inherit it): the default grey falls below 4.5:1 on
 * some of the tints. The address may break anywhere, so it never pushes a
 * 320px screen sideways.
 */
export function RegistrarContact({
  className = 'text-xs text-ccaanz-grey',
}: {
  className?: string;
}): JSX.Element {
  return (
    <p className={`[overflow-wrap:anywhere] ${className}`}>
      Having any problems? Email{' '}
      <a className="underline" href={`mailto:${REGISTRAR_EMAIL}`}>
        {REGISTRAR_EMAIL}
      </a>
    </p>
  );
}
